import { render, staticRenderFns } from "./message-login.vue?vue&type=template&id=741523a2&scoped=true"
import script from "./message-login.vue?vue&type=script&lang=js"
export * from "./message-login.vue?vue&type=script&lang=js"
import style0 from "./message-login.vue?vue&type=style&index=0&id=741523a2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741523a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('741523a2')) {
      api.createRecord('741523a2', component.options)
    } else {
      api.reload('741523a2', component.options)
    }
    module.hot.accept("./message-login.vue?vue&type=template&id=741523a2&scoped=true", function () {
      api.rerender('741523a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loginreg/message-login.vue"
export default component.exports